// use selected audiences for line item name, separate with comas
import {
  ANDROID_APP_PROMOTION,
  IOS_APP_PROMOTION
} from '../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/LineItemForm/fields'
import { format } from 'date-fns'
import { toPascalCase } from '../UploadAdCreative/UploadAdCreativeCampaignForm/Steps/CampaignNameStep/CampaignNameFields/helpers'
import { SHOW_OPTION_COUNTRIES } from '../../ReusableFormFields/GeolocationsFields/fields'

export const createNameForFacebookLineItem = ({
  startDate,
  geotargetingOption,
  countries,
  regions,
  customAudiences
}) => {
  const formattedStartDate = format(new Date(startDate), 'yyyyMMdd')

  const formattedCountries = countries
    .map(country => country.code)
    .slice(0, 12)
    .join('-')
  const formattedRegions = regions
    .map(region => {
      const formattedLabel = toPascalCase(region.label)
      return formattedLabel
    })
    .slice(0, 3)
    .join('-')

  const formattedGeolocations = geotargetingOption === SHOW_OPTION_COUNTRIES ? formattedCountries : formattedRegions

  const audiencesNames = customAudiences
    .slice(0, 4)
    .map(audience => {
      const labelInPascalCase = toPascalCase(audience.label)
      // Audiences should be truncated at 12 characters
      return labelInPascalCase.slice(0, 12)
    })
    .join('_')

  return [formattedStartDate, formattedGeolocations, audiencesNames].filter(Boolean).join('_')
}

export const createNameFromCustomAudiences = (customAudiences, placementsOption) => {
  const audiencesNames = customAudiences.map(audience => audience.label)

  if (audiencesNames.length) {
    let finalName = ''

    const isMoreThanThreeAudiences = audiencesNames.length > 3

    // use only first three audiences, if there are more provided
    const audiencesToCreateName = isMoreThanThreeAudiences ? audiencesNames.slice(0, 3) : audiencesNames

    for (let i = 0; i < audiencesToCreateName.length; i++) {
      if (i > 0) {
        const newFinalName = finalName + `, ${audiencesToCreateName[i]}`

        // limit final name to 400 characters, break loop if length exceeds
        if (newFinalName.length > 400) break

        finalName = newFinalName
      } else {
        finalName += audiencesToCreateName[i]
      }
    }

    if (placementsOption === ANDROID_APP_PROMOTION || placementsOption === IOS_APP_PROMOTION) {
      const namePrefix = placementsOption === ANDROID_APP_PROMOTION ? 'Android: ' : 'iOS: '
      finalName = `${namePrefix}${finalName}`
    }

    return isMoreThanThreeAudiences ? `${finalName}...` : finalName
  } else {
    return 'Broad targeting'
  }
}
